export enum TargetAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_TARGET_LIST = "UPDATE_TARGET_LIST",
    UPDATE_TARGET = "UPDATE_TARGET",
    UPDATE_TARGET_SEARCH_REQ = "UPDATE_TARGET_SEARCH_REQ",
    ADD_TARGET_LIST = "ADD_TARGET_LIST",
    UPDATE_EMPLOYEE_LIST = "UPDATE_EMPLOYEE_LIST",
}